export default {
  data() {
    return {
      //是否过高
      isHeighter: true,
      airTemperatureLowerLimit: '',
      airTemperatureUpperLimit: '',
      airHumidityLowerLimit: '',
      airHumidityUpperLimit: '',
      statusOptionList: [{
        value: "1",
        text: "过低",
        iconstyle: {
          "background-color": "#00FFD4"
        },
        textStyle: {
          color: '#00FFD4'
        }
      }, {
        value: "2",
        text: "正常",
        iconstyle: {
          "background-color": "#34FF00"
        },
        textStyle: {
          color: '#34FF00'
        }
      }, {
        value: "3",
        text: "过高",
        iconstyle: {
          "background-color": "#FF0000"
        },
        textStyle: {
          color: '#FF0000'
        }
      }]
    };
  },
  props: {
    number: {
      type: String,
      default: ""
    }
  },
  watch: {
    number(newVal, oldVal) {
      console.log(newVal, '值变了');
      this.getThreshold(newVal);
    }
  },
  computed: {
    greenhouseLastestData() {
      return JSON.parse(window.localStorage.getItem("plotInfo")).greenhouseVoList[0];
    },
    isTempHeighter() {
      console.log(this.airTemperatureUpperLimit, 'this.airTemperatureUpperLimit');
      if (this.greenhouseLastestData.airTemperature > this.airTemperatureUpperLimit) {
        return '3';
      }
      if (this.greenhouseLastestData.airTemperature < this.airTemperatureLowerLimit) {
        return '1';
      }
      if (this.greenhouseLastestData.airTemperature >= this.airTemperatureLowerLimit && this.greenhouseLastestData.airTemperature <= this.airTemperatureUpperLimit) {
        return '2';
      }
    },
    isHumHeighter() {
      if (this.greenhouseLastestData.airHumidity > this.airHumidityUpperLimit) {
        return '3';
      }
      if (this.greenhouseLastestData.airHumidity < this.airHumidityLowerLimit) {
        return '1';
      }
      if (this.greenhouseLastestData.airHumidity >= this.airHumidityLowerLimit && this.greenhouseLastestData.airHumidity <= this.airHumidityUpperLimit) {
        return '2';
      }
    }
  },
  mounted() {
    // this.getThreshold(this.number)
  },
  methods: {
    initChart() {},
    // 获取阈值信息
    async getThreshold(equipmentNumber) {
      let params = {
        equipmentNumber
      };
      let {
        code,
        rows
      } = await this.$api.getEquipmentThresholdList(params);
      if (code == '200') {
        this.airHumidityLowerLimit = rows[0].airHumidityLowerLimit;
        this.airHumidityUpperLimit = rows[0].airHumidityUpperLimit;
        this.airTemperatureLowerLimit = rows[0].airTemperatureLowerLimit;
        this.airTemperatureUpperLimit = rows[0].airTemperatureUpperLimit;
      }
      console.log(rows, '阈值信息');
    },
    lookDetail() {
      console.log(111);
      this.$emit('lookDetail');
    }
  }
};